// src/timestamps.ts
var toEpochMs = (iso) => {
  if (!iso) return void 0;
  const ms = new Date(iso).getTime();
  return Number.isNaN(ms) ? void 0 : ms;
};
var toEpochMsOr = (iso, fallback) => toEpochMs(iso) ?? fallback;
var isPast = (iso) => {
  const ms = toEpochMs(iso);
  return ms !== void 0 && ms < Date.now();
};

export {
  toEpochMs,
  toEpochMsOr,
  isPast
};
